"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Typing: ['typing', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,8a3,3,0,0,0-3-3H3A3,3,0,0,0,0,8v8a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-2,8a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H21a1,1,0,0,1,1,1Z', 'M8,10A1,1,0,0,0,8,8H5a1,1,0,0,0,0,2h.25a.25.25,0,0,1,.25.25v3.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H8a1,1,0,0,0,0-2H7.75a.25.25,0,0,1-.25-.25v-3.5A.25.25,0,0,1,7.75,10Z']],
  ChecklistAlternate: ['checklist-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,0H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V3A3,3,0,0,0,21,0Zm1,21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H21a1,1,0,0,1,1,1Z', 'M11.249,4.5a1.251,1.251,0,0,0-1.75.25L7.365,7.6l-.482-.481A1.25,1.25,0,0,0,5.116,8.883l1.5,1.5A1.262,1.262,0,0,0,8.5,10.249l3-4A1.25,1.25,0,0,0,11.249,4.5Z', 'M11.249,13.5a1.251,1.251,0,0,0-1.75.25L7.365,16.6l-.482-.481a1.25,1.25,0,1,0-1.767,1.768l1.5,1.5A1.265,1.265,0,0,0,8.5,19.249l3-4A1.25,1.25,0,0,0,11.249,13.5Z', 'M18.5,7.749H14a1.25,1.25,0,0,0,0,2.5h4.5a1.25,1.25,0,0,0,0-2.5Z', 'M18.5,15.749H14a1.25,1.25,0,0,0,0,2.5h4.5a1.25,1.25,0,1,0,0-2.5Z']],
  TaskChecklistAdd: ['task-checklist-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5,10.249h6.5a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5,13.749H8a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5,17.25H7.75a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5.25,6.249h8.5A.25.25,0,0,0,14,6V3a.251.251,0,0,0-.25-.25H12V2.5A2.509,2.509,0,0,0,8.821.09,2.559,2.559,0,0,0,7,2.587v.162H5.25A.251.251,0,0,0,5,3V6A.25.25,0,0,0,5.25,6.249ZM9.5,1.5a.75.75,0,1,1-.75.75A.75.75,0,0,1,9.5,1.5Z', 'M10.96,22.105a.251.251,0,0,0-.2-.106H2.5a.5.5,0,0,1-.5-.5V5.249a.5.5,0,0,1,.5-.5h.75A.25.25,0,0,0,3.5,4.5V3a.251.251,0,0,0-.25-.25H2a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2H12.125a.25.25,0,0,0,.162-.44A8,8,0,0,1,10.96,22.105Z', 'M18.711,9.6A.251.251,0,0,0,19,9.348v-4.6a2,2,0,0,0-2-2H15.75A.251.251,0,0,0,15.5,3V4.5a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.5.5V9.257a.25.25,0,0,0,.264.25c.079,0,.157-.008.236-.008A7.8,7.8,0,0,1,18.711,9.6Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.5,7.25H18.5a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H15a.75.75,0,1,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,0,1,1.5,0v1.5a.25.25,0,0,0,.25.25H20a.75.75,0,0,1,0,1.5Z']],
  Checklist: ['checklist', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,0H2.5A2.5,2.5,0,0,0,0,2.5v19A2.5,2.5,0,0,0,2.5,24h19A2.5,2.5,0,0,0,24,21.5V2.5A2.5,2.5,0,0,0,21.5,0Zm-3,9.5H14a1,1,0,0,1,0-2h4.5a1,1,0,0,1,0,2Zm1,8a1,1,0,0,1-1,1H14a1,1,0,0,1,0-2h4.5A1,1,0,0,1,19.5,17.5ZM11.3,5.6l-3,4a1,1,0,0,1-.729.4L7.5,10a1,1,0,0,1-.707-.293l-1.5-1.5A1,1,0,0,1,6.707,6.792l.685.685L9.7,4.4a1,1,0,0,1,1.6,1.2Zm0,10-3,4a1.018,1.018,0,0,1-1.507.107l-1.5-1.5a1,1,0,0,1,1.414-1.414l.685.685L9.7,14.4a1,1,0,0,1,1.6,1.2Z']],
  PaperWrite: ['paper-write', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,18.587a1,1,0,0,0-1,1V21.75a.25.25,0,0,1-.249.25l-15.5.024A.25.25,0,0,1,2,21.774V4.749a.25.25,0,0,1,.25-.25H3.5a1,1,0,1,0,0-2H2A1.99,1.99,0,0,0,0,4.474V22.025A1.989,1.989,0,0,0,2,24H18a1.989,1.989,0,0,0,2-1.974V19.587A1,1,0,0,0,19,18.587Z', 'M16.5,4.5h1.25a.25.25,0,0,1,.25.25V5.5a1,1,0,0,0,2,0v-1a2,2,0,0,0-2-2H16.5a1,1,0,0,0,0,2Z', 'M7,5.5h6A1.5,1.5,0,0,0,14.5,4V3.5A1.5,1.5,0,0,0,13,2H12A2,2,0,0,0,8,2H7A1.5,1.5,0,0,0,5.5,3.5V4A1.5,1.5,0,0,0,7,5.5Z', 'M4,10a1,1,0,0,0,1,1h8a1,1,0,0,0,0-2H5A1,1,0,0,0,4,10Z', 'M5,14a1,1,0,0,0,0,2H9.5a1,1,0,0,0,0-2Z', 'M23.415,8.241a2.021,2.021,0,0,0-2.828,0l-7.869,7.87a.493.493,0,0,0-.111.168l-1.414,3.535a.5.5,0,0,0,.65.649l3.535-1.414a.48.48,0,0,0,.168-.11l7.869-7.869A2,2,0,0,0,23.415,8.241Z']],
  PencilWrite3Alternate: ['pencil-write-3-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,11.673H19.5a1,1,0,0,0,0,2h2.25a.25.25,0,0,1,.25.25v6a.25.25,0,0,1-.25.25H2.25a.25.25,0,0,1-.25-.25v-6a.25.25,0,0,1,.25-.25H5.5a1,1,0,1,0,0-2H2a2,2,0,0,0-2,2v6.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2v-6.5A2,2,0,0,0,22,11.673Z', 'M8.109,17.07a.5.5,0,0,0,.186-.036L11.83,15.62A.526.526,0,0,0,12,15.51L19.812,7.7a.5.5,0,0,0,0-.707L17.69,4.868a.513.513,0,0,0-.707,0L9.17,12.681a.5.5,0,0,0-.111.168L7.645,16.385a.5.5,0,0,0,.464.685Z', 'M20.519,6.281a.5.5,0,0,0,.707,0L22.287,5.22a2,2,0,0,0,0-2.828,2.048,2.048,0,0,0-2.828,0L18.4,3.454a.5.5,0,0,0,0,.707Z']],
  TaskChecklistCheck: ['task-checklist-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm3,4.576L17.6,19.45a1.5,1.5,0,0,1-2.262.158l-1.5-1.5a.75.75,0,1,1,1.06-1.06l1.3,1.3a.248.248,0,0,0,.376-.027l2.732-3.643a.75.75,0,1,1,1.2.9Z', 'M5,10.249h6.5a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5,13.749H8a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5,17.25H7.75a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5.25,6.249h8.5A.25.25,0,0,0,14,6V3a.251.251,0,0,0-.25-.25H12V2.5A2.509,2.509,0,0,0,8.821.09,2.559,2.559,0,0,0,7,2.587v.162H5.25A.251.251,0,0,0,5,3V6A.25.25,0,0,0,5.25,6.249ZM9.5,1.5a.75.75,0,1,1-.75.75A.75.75,0,0,1,9.5,1.5Z', 'M10.96,22.105a.251.251,0,0,0-.2-.106H2.5a.5.5,0,0,1-.5-.5V5.249a.5.5,0,0,1,.5-.5h.75A.25.25,0,0,0,3.5,4.5V3a.251.251,0,0,0-.25-.25H2a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2H12.125a.25.25,0,0,0,.162-.44A8,8,0,0,1,10.96,22.105Z', 'M18.711,9.6A.251.251,0,0,0,19,9.348v-4.6a2,2,0,0,0-2-2H15.75A.251.251,0,0,0,15.5,3V4.5a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.5.5V9.257a.25.25,0,0,0,.264.25c.079,0,.157-.008.236-.008A7.8,7.8,0,0,1,18.711,9.6Z']],
  TaskChecklistRemove: ['task-checklist-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.5,7.25H15a.75.75,0,1,1,0-1.5h5a.75.75,0,0,1,0,1.5Z', 'M5,10.249h6.5a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5,13.749H8a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5,17.25H7.75a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5.25,6.249h8.5A.25.25,0,0,0,14,6V3a.251.251,0,0,0-.25-.25H12V2.5A2.509,2.509,0,0,0,8.821.09,2.559,2.559,0,0,0,7,2.587v.162H5.25A.251.251,0,0,0,5,3V6A.25.25,0,0,0,5.25,6.249ZM9.5,1.5a.75.75,0,1,1-.75.75A.75.75,0,0,1,9.5,1.5Z', 'M10.96,22.105a.249.249,0,0,0-.2-.106H2.5a.5.5,0,0,1-.5-.5V5.249a.5.5,0,0,1,.5-.5h.75A.25.25,0,0,0,3.5,4.5V3a.251.251,0,0,0-.25-.25H2a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2H12.125a.25.25,0,0,0,.234-.163.247.247,0,0,0-.072-.276A8.044,8.044,0,0,1,10.96,22.105Z', 'M15.75,4.749h.75a.5.5,0,0,1,.5.5V9.257a.25.25,0,0,0,.265.25c.078,0,.156-.008.235-.008a7.926,7.926,0,0,1,1.211.1.249.249,0,0,0,.2-.058A.245.245,0,0,0,19,9.348v-4.6a2,2,0,0,0-2-2H15.75A.251.251,0,0,0,15.5,3V4.5A.25.25,0,0,0,15.75,4.749Z']],
  TaskChecklistWrite: ['task-checklist-write', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5,10.249h6.5a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5,13.749H8a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5,17.25H7.75a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5.25,6.249h8.5A.25.25,0,0,0,14,6V3a.251.251,0,0,0-.25-.25H12V2.5A2.509,2.509,0,0,0,8.821.09,2.558,2.558,0,0,0,7,2.587v.162H5.25A.251.251,0,0,0,5,3V6A.25.25,0,0,0,5.25,6.249Zm5-4A.75.75,0,1,1,9.5,1.5.75.75,0,0,1,10.25,2.249Z', 'M9.052,23l.14-.7a.249.249,0,0,0-.051-.207A.252.252,0,0,0,8.947,22H2.5a.5.5,0,0,1-.5-.5V5.249a.5.5,0,0,1,.5-.5h.75A.25.25,0,0,0,3.5,4.5V3a.251.251,0,0,0-.25-.25H2a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2H8.776a.249.249,0,0,0,.249-.277A2.333,2.333,0,0,1,9.052,23Z', 'M18.884,9.747A.252.252,0,0,0,19,9.535V4.749a2,2,0,0,0-2-2H15.75A.251.251,0,0,0,15.5,3V4.5a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.5.5v5.612a.25.25,0,0,0,.427.177l.688-.688A4.383,4.383,0,0,1,18.884,9.747Z', 'M12.739,20.044a.5.5,0,0,0-.834.217l-.886,3.1a.5.5,0,0,0,.618.618l3.1-.886a.5.5,0,0,0,.217-.835Z', 'M18.771,13.228a.5.5,0,0,0-.707,0l-5.01,5.009a.5.5,0,0,0,0,.708l3,3a.5.5,0,0,0,.707,0l5.01-5.01a.5.5,0,0,0,0-.707Z', 'M19.478,11.814a.5.5,0,0,0,0,.707l3,3a.454.454,0,0,0,.327.125.617.617,0,0,0,.426-.172,2.621,2.621,0,0,0,0-3.707A2.654,2.654,0,0,0,19.478,11.814Z']],
  PencilWrite3: ['pencil-write-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,11.49H18.554a.251.251,0,0,0-.177.073l-5.191,5.19a1.991,1.991,0,0,1-.67.442L8.979,18.61a2,2,0,0,1-2.6-2.6l1.414-3.535a2,2,0,0,1,.443-.671l.314-.314H2a2,2,0,0,0-2,2v6.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2v-6.5A2,2,0,0,0,22,11.49Z', 'M9.3,12.865a.5.5,0,0,0-.11.168L7.772,16.568a.5.5,0,0,0,.111.539.509.509,0,0,0,.539.11L11.958,15.8a.468.468,0,0,0,.167-.11l7.814-7.814a.5.5,0,0,0,.147-.353.5.5,0,0,0-.147-.354L17.817,5.05a.516.516,0,0,0-.707,0Z', 'M18.525,4.343l2.121,2.121A.5.5,0,0,0,21,6.611a.494.494,0,0,0,.3-.108.421.421,0,0,0,.058-.039L22.415,5.4a2,2,0,0,0,0-2.828,2.049,2.049,0,0,0-2.829,0l-1.061,1.06a.616.616,0,0,0-.041.063.493.493,0,0,0-.105.291A.5.5,0,0,0,18.525,4.343Z']],
  TaskChecklist: ['task-checklist', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.5,9h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z', 'M17.25,13.249a.75.75,0,0,0-.75-.75h-9a.75.75,0,0,0,0,1.5h9A.75.75,0,0,0,17.25,13.249Z', 'M10,6.5h4a1,1,0,0,0,1-1V3A3.007,3.007,0,0,0,11.192.107,3.045,3.045,0,0,0,9,3.087V5.5A1,1,0,0,0,10,6.5Zm1.25-3.75A.75.75,0,1,1,12,3.5.75.75,0,0,1,11.25,2.749Z', 'M19.5,3H16.75a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H19a.5.5,0,0,1,.5.5V18.292a.5.5,0,0,1-.146.354l-3.208,3.207a.5.5,0,0,1-.353.146H5a.5.5,0,0,1-.5-.5V5.5A.5.5,0,0,1,5,5H7.25a.25.25,0,0,0,.25-.25v-1.5A.25.25,0,0,0,7.25,3H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V5A2,2,0,0,0,19.5,3Z', 'M7.5,16a.75.75,0,0,0,0,1.5h3.75a.75.75,0,0,0,0-1.5Z']],
  PenWrite1: ['pen-write-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.669,6.65a.757.757,0,0,0,1.053-.131l2.949-3.787a.538.538,0,0,1,.752-.094l.254.2-1.12,1.437a.321.321,0,0,0,.056.451L18.15,6.7a.323.323,0,0,0,.452-.056l1.58-2.029A1.93,1.93,0,0,0,17.7,1.754a.67.67,0,0,0-.105-.1l-.255-.2a2.038,2.038,0,0,0-2.857.355L11.539,5.6A.751.751,0,0,0,11.669,6.65Z', 'M10.3,12.593l1.522,1.185a.964.964,0,0,0,1.353-.168l4.436-5.7a.321.321,0,0,0-.056-.451L15.02,5.487a.323.323,0,0,0-.452.056l-4.434,5.7A.963.963,0,0,0,10.3,12.593Z', 'M8.062,17.188a.531.531,0,0,0,.534.052l3.167-1.61a.5.5,0,0,0,.081-.839L9.461,12.934a.5.5,0,0,0-.795.284l-.784,3.465A.5.5,0,0,0,8.062,17.188Z', 'M22,13.472H17.762a1,1,0,0,0,0,2H21.75a.25.25,0,0,1,.25.25v5a.25.25,0,0,1-.25.25H2.25a.25.25,0,0,1-.25-.25v-5a.25.25,0,0,1,.25-.25H5.19a1,1,0,0,0,0-2H2a2,2,0,0,0-2,2v5.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2v-5.5A2,2,0,0,0,22,13.472Z']],
  ChecklistPen: ['checklist-pen', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.968,7.413a.752.752,0,0,0-1.055.118L5.437,9.376,4.53,8.469A.75.75,0,0,0,3.469,9.53l1.5,1.5a.765.765,0,0,0,1.116-.062l2-2.5A.751.751,0,0,0,7.968,7.413Z', 'M6.913,13.031,5.437,14.876l-.907-.907A.75.75,0,0,0,3.469,15.03l1.5,1.5a.765.765,0,0,0,1.116-.062l2-2.5a.75.75,0,1,0-1.172-.937Z', 'M20.5,8H17a.5.5,0,0,0-.5.5V18A1.5,1.5,0,0,0,18,19.5h1.5A1.5,1.5,0,0,0,21,18V8.5A.5.5,0,0,0,20.5,8Z', 'M24,3a3,3,0,0,0-3-3H17a.5.5,0,0,0-.5.5v6A.5.5,0,0,0,17,7h3.5a.5.5,0,0,0,.5-.5V2a1,1,0,0,1,1,1l0,8a1,1,0,1,0,2,0Z', 'M15,3a1,1,0,0,0-1-1H1A1,1,0,0,0,0,3V21a1,1,0,0,0,1,1H14a1,1,0,0,0,0-2H2V4H14A1,1,0,0,0,15,3Z', 'M12.5,9.249H10a.75.75,0,0,0,0,1.5h2.5a.75.75,0,0,0,0-1.5Z', 'M12.5,14.749H10a.75.75,0,1,0,0,1.5h2.5a.75.75,0,0,0,0-1.5Z', 'M18.749,20.5a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.5A1,1,0,0,0,18.749,20.5Z']]
};
exports["default"] = _default;